import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Collapse } from "@mui/material"
import { ButtonArea, theme } from "@op-str/op-component-library"
import React, { useState } from "react"
import styled from "styled-components"
import { HtmlContainer } from "../HtmlContainer"

export type ExpandItemProps = {
  title?: string
  content?: string
  isForceOpen?: boolean
  onToggle?: (value: boolean) => void
  className?: string
}

export const ExpandItem = (props: ExpandItemProps) => {
  const { title, content, isForceOpen = false, onToggle, className } = props

  const [isOpen, setIsOpen] = useState(isForceOpen)
  const shouldOpen = isOpen || isForceOpen

  const handleClickArrow = () => {
    onToggle && onToggle(!shouldOpen)
    setIsOpen(!shouldOpen)
  }

  return (
    <Root className={className}>
      <TitleContainer onClick={handleClickArrow}>
        <Title data-cy="questionTitle">{title ?? ""}</Title>
        <RotationalButtonAreaWithoutRipple $isOpen={shouldOpen} data-cy="expandButton">
          <ExpandMoreIcon color="primary" />
        </RotationalButtonAreaWithoutRipple>
      </TitleContainer>
      <Collapse in={shouldOpen}>
        <CustomHtmlContainer data-cy="expandContent" dangerouslySetInnerHTML={{ __html: content ?? "" }} />
      </Collapse>
    </Root>
  )
}

const Root = styled.div`
  min-height: 88px;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const RotationalButtonAreaWithoutRipple = styled(ButtonArea)<{ $isOpen: boolean }>`
  transition: 0.2s;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0)")};
  min-height: initial;
  min-width: initial;

  &:hover {
    background-color: initial;
  }

  .MuiTouchRipple-root {
    display: none;
  }
`

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`

const Title = styled.div`
  font-family: ${theme.font.bold};
  width: fit-content;
`

const CustomHtmlContainer = styled(HtmlContainer)`
  & img {
    max-width: 850px;
  }
`
